import React from "react";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  ResourcesInfoContainer,
  ResourcesSingleFrameContainter,
  ResourcesTitleContainter,
} from "./Resources.styles";
import { SampleReportsData } from "./SampleReportsData";

interface SampleReportsProps {
  showTitle?: boolean;
}

export const SampleReports = ({
  showTitle = true,
}: SampleReportsProps): React.ReactElement => {
  const { deviceType } = useDeviceHook();

  return (
    <ResourcesSingleFrameContainter>
      {showTitle && (
        <ResourcesTitleContainter>
          {GetTypographyContent({
            content: "Sample Reports",
            isBold: true,
            isCaps: true,
            size: "large",
            textColor: "greyMedium",
          })}
        </ResourcesTitleContainter>
      )}
      <ResourcesInfoContainer deviceType={deviceType} role="list">
        {SampleReportsData()}
      </ResourcesInfoContainer>
    </ResourcesSingleFrameContainter>
  );
};
